module.exports = __webpack_public_path__ + "static/media/Quoc_huy.61f3288e.png";